import UtmHandler from './TiberJsUtm';
UtmHandler.extract();

window.tiber = window.tiber || {};
window.tiber.UtmHandler = UtmHandler;
